<template>
  <div class="loader">
    <div class="loader__spinner" />
  </div>
</template>

<script lang="ts" src="./AppLoader.ts"></script>

<style scoped lang="scss" src="./AppLoader.scss"></style>
